import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,_vm._b({staticClass:"cursor-pointer",attrs:{"small":"","dark":"","color":_vm.color},on:{"click":function($event){return _vm.$emit('click')}}},'v-chip',_vm.$attrs,false),[_vm._t("default",[_vm._v(_vm._s(_vm.source)+" "),_c(VIcon,{staticClass:"ml-2"},[_vm._v(" mdi-folder-information-outline ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }